<template>
  <div class="city-panel">
    <Card :dis-hover="true">
      <Menu
        mode="horizontal"
        :stop-propagation="true"
        theme="light"
        :active-name="menuActiveName"
        @on-select="onGroupClick"
      >
        <MenuItem v-for="ckey in cityKeyList" :key="ckey" :name="ckey">
          {{ ckey }}
        </MenuItem>
      </Menu>
      <Row>
        <i-col span="24" style="margin-bottom: 5px;">
          <p class="hot-city">热门城市</p>
          <p class="b lr wrap">
            <Button
              style="margin: 0 10px 6px 0;"
              v-for="city in hotCities"
              :key="city.id"
              @click="onCityClick(city)"
              >{{ city.nm }}</Button
            >
          </p>
        </i-col>
      </Row>
      <Row
        style="margin-top: 15px;"
        v-for="(cityGroup, groupIdx) in cityList[currentGroupIndex]"
        :key="groupIdx"
      >
        <i-col style="margin-bottom: 5px;" span="24">
          {{ cityGroup.ckey }}
        </i-col>
        <i-col span="24">
          <p class="b lr wrap">
            <Button
              style="margin: 0 10px 6px 0;"
              v-for="city in cityGroup.cityList"
              :key="city.id"
              @click="onCityClick(city)"
              >{{ city.nm }}</Button
            >
          </p>
        </i-col>
      </Row>
    </Card>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { geo, getAllCity } from '@/service/common';
import sessionStorage from '@/utils/storage/sessionStorage';
import { tryCatch } from '../../utils';
export default {
  name: 'CityPanel',
  data() {
    return {
      hotCities: [],
      cityList: [],
      cityKeyList: [],
      currentGroupIndex: 0
    };
  },
  async mounted() {
    let cities = sessionStorage.get('cities');
    if (!cities || !cities.length) {
      cities = await getAllCity();
      sessionStorage.set('cities', cities);
    }
    this.hotCities = cities.filter(item => +item.is_hot === 1);
    this.groupCityByChar(cities);
  },
  methods: {
    groupCityByChar(cities) {
      let map = {};
      let temps = [];
      cities.map(item => {
        if (item.py) {
          let ekey = item.py.charAt(0).toUpperCase();
          temps = map[ekey] || [];
          temps.push(item);
          map[ekey] = temps;
        }
      });
      let list = [];
      for (let gkey in map) {
        list.push({
          ckey: gkey,
          cityList: map[gkey]
        });
      }
      list = list.sort(
        (li1, li2) => li1.ckey.charCodeAt(0) - li2.ckey.charCodeAt(0)
      );
      this.reGroupCity(list);
    },
    reGroupCity(list) {
      let chunk = 4;
      let result = [];
      for (var i = 0, j = list.length; i < j; i += chunk) {
        result.push(list.slice(i, i + chunk));
      }
      this.cityList = result;

      let cityKeyList = [];
      result.map(item => {
        let ckeys = '';
        item.map(ritem => {
          ckeys += ritem.ckey;
        });
        cityKeyList.push(ckeys);
      });
      this.cityKeyList = cityKeyList;
    },
    onGroupClick(name) {
      const gourpIndex = this.cityKeyList.findIndex(ckey => ckey === name);
      this.currentGroupIndex = gourpIndex;
    },
    onCityClick(city) {
      tryCatch(
        async () => {
          const cityInfo = await this.getCityPos(city);
          this.$emit('on-choosed', { ...city, amap: cityInfo });
        },
        () => {
          this.$emit('on-choosed', city);
        }
      );
    },
    getCityPos(city = {}) {
      return new Promise((resolve, reject) => {
        const cityName = city.nm;
        geo({
          address: cityName
        })
          .then(resolve)
          .catch(reject);
      });
    }
  },
  computed: {
    ...mapState('common', ['config']),
    menuActiveName() {
      return this.cityKeyList[this.currentGroupIndex];
    }
  }
};
</script>

<style lang="scss" scoped>
.city-panel {
  max-width: 700px;
  max-height: 500px;
  overflow-y: auto;
  /* 面板本体：默认箭头。
     它挂在 iView 的 .ivu-dropdown-item 里，而那个容器自带 cursor: pointer
     （view-design/dist/styles/iview.css），会被整块面板继承 ——
     原来的表现就是「弹框里鼠标到处都是手」。
     cursor 是继承属性：这里显式声明 default，面板及其内部所有非可点区域回到箭头 */
  cursor: default;
  /* 只有真正可点的两处才是手型：城市按钮 + 顶部字母分组 */
  /deep/ .ivu-btn,
  /deep/ .ivu-menu-item {
    cursor: pointer;
  }
  /* 滚动条做明显一些：可见的浅灰轨道 + 稍深的滑块（面板底色保持默认纯白） */
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #e8eaec;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #c5c8ce;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #a9aeb8;
  }
  .hot-city {
    margin-top: 15px;
    margin-bottom: 5px;
  }
}
</style>
